
































































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {SavePatPna} from "@/api/hd"

@Component({
	components: {}
})
export default class XX extends AbpBase {
	@Prop() data: any
	@Prop() value: boolean
	model: any = {
		patientId: this.data.patient.id,

	}
	foods = ['苹果', '西瓜', '巧克力', '雪糕',]

	created() {
		if (this.data.mode === 'add') {

		} else {
			this.model = Object.assign({}, this.data.item)
		}
	}

	async save() {

	}

	get dialogTitle() {
		return `${this.data.mode === 'add' ? '新增' : '编辑'}饮食记录`
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	cancel() {
		this.$emit('input', false);
	}

	rules = {}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/addOrEditFood.vue